import classnames from "classnames";
import React from "react";
import environment from "web/script/modules/environment";
import CheckboxFilterItem from "web/react/components/checkbox-filter-item/checkbox-filter-item";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption } from "web/types/universal-filters";
// This is only temporary disabled cause we are adding different css
// files depending on if the uj_tree_filter_all_screens flag
// is on or off.
// eslint-disable-next-line css-modules/no-unused-class
import styles1 from "./category-filter-item.css";
// eslint-disable-next-line css-modules/no-unused-class
import styles2 from "./category-filter-item2.css";

interface CategoryFilterItemProps extends StandardFilterProps {
    item: CategoryFilterOption;
}

function CategoryFilterItem({
    item,
    pendingFilterInfo,
    onClick,
}: CategoryFilterItemProps): JSX.Element {
    const open = pendingFilterInfo.getChecked(item);
    let treeStructure = environment.getFeature("uj_tree_filter_all_screens");
    let styles = treeStructure ? styles2 : styles1;

    // This url can change each time the user clicks something
    let expandableId = `category_filter_item_${item.url}`;
    return (
        <li className={styles.filterGroup}>
            <CheckboxFilterItem
                {...{
                    item,
                    pendingFilterInfo,
                    onClick,
                }}
                ariaControls={expandableId}
                hasChildren={item.children.length > 0}
            />
            {item.children.length > 0 && (
                <ol
                    className={classnames(styles.subOptionsGroup, {
                        [styles.open]: open,
                        [styles.closed]: !open,
                    })}
                    id={expandableId}
                >
                    {item.children.map((item) => {
                        return (
                            <li key={item.value}>
                                <CheckboxFilterItem
                                    {...{
                                        item,
                                        pendingFilterInfo,
                                        onClick,
                                    }}
                                    isSmallItem={true}
                                />
                            </li>
                        );
                    })}
                </ol>
            )}
        </li>
    );
}

export default CategoryFilterItem;
